var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"huge-savings-badge"},[_vm._v("Huge Savings")])
}
var staticRenderFns = []

export { render, staticRenderFns }